const emailAccounts = (state) => state.emailAccounts;
const hasEmailAccounts = (state) => state.emailAccounts.length > 0;

const getEmailAccountById = (state) => (id) => state.emailAccountsCache.find((emailAccount) => emailAccount.id === id);

const emailAccountsByUser = (state) => state.emailAccountsByUser;

const hasEmailAccountById = (state) => (id) => typeof state.emailAccountsCache.find((emailAccount) => emailAccount.id === id) !== "undefined";
const hasEmailAccountsByUser = (state) => state.emailAccountsByUser.length > 0;

export default {
  emailAccounts,
  hasEmailAccounts,
  hasEmailAccountById,
  getEmailAccountById,
  emailAccountsByUser,
  hasEmailAccountsByUser,
};
